import { AuthUser, MarketplaceSubGroup } from "@shared/types";
import { dateToMoment } from "@shared/utils/date";

export const buildMarketPlaceGroupEvent = (
  marketplaceGroup: MarketplaceSubGroup,
  pagePosition: number
) => {
  return {
    marketplaceGroupId: marketplaceGroup.group_id,
    marketplaceGroupAverageRating: marketplaceGroup.avg_stars || -1,
    marketplaceGroupDiscountOffered: marketplaceGroup.discount,
    marketplaceGroupOffersFreeTrial: marketplaceGroup.has_free_trial,
    marketplaceGroupReviewsCount: marketplaceGroup.num_of_reviewers,
    marketplaceGroupDollarSignsCount: marketplaceGroup.price_number,
    marketplaceGroupPagePosition: pagePosition,
  };
};

export const getAppcuesAndIntercomUserProperties = (
  user: AuthUser,
  isOnboarding: boolean
) => {
  const getParsedTimestamp = (timestamp?: number | null) => {
    return timestamp
      ? dateToMoment(timestamp, true).millisecond(0).unix()
      : undefined;
  };

  const attributes: any = {
    "User Id": user.id,
    Plan: user.package,
    "Is Expired": user.isExpired(),
    "Is Onboarding": isOnboarding,
    "Is Admin": user.is_admin,
    "Is Trial": user.is_trial,
    "Auto Trading Enabled": user.user_auto_trading_enabled,
    "Discord Connected": user.is_discord_connected,
    "Telegram Connected": user.is_telegram_connected,
    "Mobile App User": user.is_mobile_app_user,
    "Connected Exchange": user.has_clients_connected,
    "Registration Date": getParsedTimestamp(user.registration_timestamp)!,
    "Expiration Date": getParsedTimestamp(user.expiration_timestamp)!,
    // "User Labels": user.labels,
    "Has Groups": !!user.has_groups,
  };
  if (user.package_duration) {
    attributes["Duration"] = user.package_duration;
  }
  return attributes;
};

export const getIntercomAppId = (env: string | undefined) => {
  let appId = "";
  if (env === "production") {
    appId = "wrsw0nb0";
  } else if (env === "staging") {
    appId = "kxe9cspv";
  }
  return appId;
};
